import {
  CustomerGroupListItem,
  CustomerGroupListItemFromDb,
} from "../lib/models/CustomerGroupListItem";
import HostService from "../services/Host";
import { CustomerGroupFilterState, ICustomerGroupExport } from "../types/index";
import { handleResponse2 } from "./utilities";
import { getCustomerGroupFilterForQuery } from "./utilities";

export async function fetchCustomerGroupList(token: string) {
  const url = `${HostService.getApiHost()}/v2/customer-groups`;
  const response = await fetch(url, {
    headers: {
      token,
    },
  });
  return handleResponse2<CustomerGroupListItemFromDb[]>(response);
}

export async function saveCustomerGroup(
  token: string,
  customerGroupFilter: CustomerGroupFilterState,
  groupName: string
) {
  const url = `${HostService.getApiHost()}/v2/customer-groups`;
  const postData: Partial<CustomerGroupListItem> = {
    groupName,
    filterSettings: getCustomerGroupFilterForQuery(customerGroupFilter, {
      saveCustomerGroup: true,
    }) as CustomerGroupFilterState,
  };
  const response = await fetch(url, {
    body: JSON.stringify(postData),
    headers: {
      "Content-Type": "application/json",
      token,
    },
    method: "POST",
  });
  return handleResponse2<CustomerGroupListItem>(response);
}

export async function editCustomerGroup({
  token,
  filterSettings,
  groupName,
  customerGroupUuid,
}: {
  token: string;
  filterSettings?: CustomerGroupFilterState;
  groupName?: string;
  customerGroupUuid: string;
}) {
  const url = `${HostService.getApiHost()}/v2/customer-groups/${customerGroupUuid}/`;
  const payload: Partial<CustomerGroupListItem> = {
    groupName,
    filterSettings: filterSettings
      ? (getCustomerGroupFilterForQuery(filterSettings, {
          saveCustomerGroup: true,
        }) as CustomerGroupFilterState)
      : undefined,
  };
  const response = await fetch(url, {
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
      token,
    },
    method: "PUT",
  });
  return handleResponse2<CustomerGroupListItem>(response);
}

export async function deleteCustomerGroup(token: string, uuid: string) {
  const url = `${HostService.getApiHost()}/v2/customer-groups/${uuid}`;
  const response = await fetch(url, {
    headers: { token },
    method: "DELETE",
  });
  return handleResponse2<{ uuid: string }>(response);
}

export async function saveCustomerGroupExport(
  token: string,
  customerGroupUuid: string,
  comment?: string | null
) {
  const url = `${HostService.getApiHost()}/v2/customer-groups/${customerGroupUuid}/group-exports/`;
  const postData: Partial<ICustomerGroupExport> = {
    comment: comment ?? "",
  };
  const response = await fetch(url, {
    body: JSON.stringify(postData),
    headers: {
      "Content-Type": "application/json",
      token,
    },
    method: "POST",
  });

  return handleResponse2<ICustomerGroupExport>(response);
}

export async function downloadCustomerGroupExport(
  token: string,
  customerGroupUuid: string,
  customerGroupExportUuid: string
) {
  const url = `${HostService.getApiHost()}/v2/customer-groups/${customerGroupUuid}/group-exports/${customerGroupExportUuid}`;
  const response = fetch(url, {
    headers: {
      token,
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    method: "GET",
  });
  return (await response).arrayBuffer();
}

export async function deleteCustomerGroupExport(
  token: string,
  customerGroupUuid: string,
  customerGroupExportUuid: string
) {
  const url = `${HostService.getApiHost()}/v2/customer-groups/${customerGroupUuid}/group-exports/${customerGroupExportUuid}`;
  const response = await fetch(url, {
    headers: {
      token,
    },
    method: "DELETE",
  });

  return handleResponse2<ICustomerGroupExport>(response);
}



// WEBPACK FOOTER //
// ./src/api/customer-groups.tsx